import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { SectionLink } from "./SectionLink";
import { HERO_IMAGE, PHONE_DISPLAY, PHONE_HREF, SERVICES } from "./data";

export const Hero = () => (
  <section id="home" data-testid="hero-section" className="bg-brand-deep text-white">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 py-16 sm:px-8 lg:grid-cols-[1.05fr_1fr] lg:gap-16 lg:py-24">
      <div>
        <p className="eyebrow eyebrow-light animate-fade-up" data-testid="hero-eyebrow">Business Technology | Chatham-Kent</p>
        <h1 data-testid="hero-heading" className="mt-6 animate-fade-up font-heading text-4xl font-semibold leading-[1.1] tracking-tight [animation-delay:80ms] sm:text-5xl lg:text-6xl">
          Modern technology for modern businesses.
        </h1>
        <p data-testid="hero-description" className="mt-6 max-w-xl animate-fade-up text-base leading-relaxed text-white/80 [animation-delay:160ms] md:text-lg">
          Technology explained clearly, delivered professionally, and supported after installation.
        </p>
        <p className="mt-3 max-w-xl animate-fade-up text-sm leading-relaxed text-white/60 [animation-delay:160ms]">
          One local partner for IT, Microsoft 365, networks, phones, cameras and advertisement TVs.
        </p>
        <div className="mt-9 flex animate-fade-up flex-col gap-3 [animation-delay:240ms] sm:flex-row sm:items-center sm:gap-4">
          <SectionLink hash="#contact" data-testid="hero-request-quote-button" className="btn-primary-dark">
            Request a Quote <ArrowRight className="h-4 w-4" />
          </SectionLink>
          <SectionLink hash="#services" data-testid="hero-explore-services-button" className="btn-secondary-light">
            Explore Services
          </SectionLink>
        </div>
        <a href={PHONE_HREF} data-testid="hero-call-button" className="mt-7 inline-flex animate-fade-up items-center gap-2 text-sm font-medium text-white/80 transition-colors [animation-delay:300ms] hover:text-brand-cyan">
          <Phone className="h-4 w-4 text-brand-cyan" strokeWidth={1.75} /> Call {PHONE_DISPLAY}
        </a>
      </div>
      <div className="animate-fade-up [animation-delay:200ms]">
        <img src={HERO_IMAGE} alt="Modern conference room with a large wall display and ceiling security camera" className="aspect-[4/3] w-full rounded-2xl object-cover" data-testid="hero-image" />
      </div>
    </div>
  </section>
);

export const ExploreSolutions = () => (
  <section data-testid="explore-solutions" className="border-b border-brand-surface bg-white">
    <div className="mx-auto max-w-7xl px-5 py-10 sm:px-8">
      <p className="eyebrow">Explore Our Solutions</p>
      <ul className="mt-6 grid grid-cols-3 gap-3 sm:grid-cols-6">
        {SERVICES.map(({ id, slug, label, icon: Icon }) => (
          <li key={id}>
            <Link to={`/services/${slug}`} data-testid={`explore-link-${id}`} className="flex h-full flex-col items-center gap-2.5 rounded-xl border border-brand-surface bg-white px-2 py-4 text-center transition-[border-color,box-shadow] duration-200 hover:border-brand-action hover:shadow-sm">
              <Icon className="h-6 w-6 text-brand-blue" strokeWidth={1.6} />
              <span className="font-heading text-xs font-semibold uppercase tracking-wider text-brand-navy">{label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
